import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { useAuth } from "../../providers/AuthProvider";
import { DASHBOARD_PRFIX } from "../../config";
import { Logo } from "./Logo";

const Header = () => {
  const { isAuthenticated, logout } = useAuth();
  const [isNavOpen, setIsNavOpen] = useState(false);
  const navigate= useNavigate();

  const toggleNav = () => {
    setIsNavOpen(!isNavOpen);
  };

  const handleClick = () => {
    navigate(`${isAuthenticated ? `/${DASHBOARD_PRFIX}` : "/auth/login"}`)
  }

  return (
    <header className="header-style-1">
      {/* Start Topbar */}
      <div className="topbar-style-1">
        <div className="container">
          <div className="row justify-content-center my-2">
            <div className="col-lg-6 col-md-6 col-12">
              <div className="left-side">
                <p className="text-custom-white no-margin">Ventura County Credit Union</p>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-12">
              {/* Add something if needed */}
            </div>
          </div>
        </div>
      </div>
      {/* End Topbar */}
      {/* Start Navigation */}
      <nav className="navbar navbar-expand-lg navbar-light main-navigation-style-1">
        <div className="container">
          <Link className="navbar-brand" to="/">
            <Logo />
          </Link>
          <button className="navbar-toggler" type="button" onClick={toggleNav} aria-controls="navbarNav" aria-expanded={isNavOpen} aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className={`collapse navbar-collapse ${isNavOpen ? 'show' : ''}`} id="navbarNav">
            <ul className="navbar-nav ml-auto">
              <li className="nav-item mr-3 py-2">
                <Link className="menu-item text-custom-white" to="/" onClick={() => setIsNavOpen(false)}>Home</Link>
              </li>
              <li className="nav-item mr-3 py-2">
                <Link className="menu-item text-custom-white" to="/about" onClick={() => setIsNavOpen(false)}>About</Link>
              </li>
              <li className="nav-item mr-3 py-2">
                <Link className="menu-item text-custom-white" to="/service" onClick={() => setIsNavOpen(false)}>Service</Link>
              </li>
            </ul>
            <div className="navbar-nav">
              <div className="nav-item mr-lg-3">
                <button className="text-white px-4 btn-submit nav-link" onClick={handleClick}>
                  {isAuthenticated ? "Dashboard" : "Login"}
                </button>
              </div>
              {isAuthenticated && (
                <div className="nav-item mt-3 mt-lg-0">
                  <button onClick={() => { logout(); setIsNavOpen(false); }} className="text-white px-4 btn-submit nav-link">Logout</button>
                </div>
              )}
            </div>
          </div>
        </div>
      </nav>

      {/* End Navigation */}
    </header>
  );
};

export default Header;
